import { render, staticRenderFns } from "./blockdate.vue?vue&type=template&id=cae6a1a6&scoped=true&"
import script from "./blockdate.vue?vue&type=script&lang=js&"
export * from "./blockdate.vue?vue&type=script&lang=js&"
import style0 from "./blockdate.vue?vue&type=style&index=0&id=cae6a1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae6a1a6",
  null
  
)

export default component.exports